import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {NumberToPersianLetters, ToxicDigitsFixToEnglish} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsStaffInsuranceEditModal = (props: {
    active: boolean,
    closeHandler: any,
    staffId: string,
    hasInsurance: boolean,
    cost: number,
    days: number,
    onDone: any,
}) => {
    const ids = {
        cost: useId(),
        days: useId(),
    };
    const [hasInsurance, setHasInsurance] = useState(true);
    const [cost, setCost] = useState('0');
    const [days, setDays] = useState('0');
    const [err, setErr] = useState({
        cost: false,
        days: false,
    });
    useEffect(() => {
        const isActive = props.active;
        const _has = props.hasInsurance;
        const _cost = props.cost;
        const _days = props.days;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setHasInsurance(_has);
            setCost(_cost.toString());
            setDays(_days.toString());
            setErr({
                cost: false,
                days: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const _has = hasInsurance;
        let _cost = cost.toString().trim();
        let _days = days.toString().trim();
        let errors = {
            cost: false,
            days: false,
        };
        let stop = false;
        if (_has) {
            if (_cost === '' || parseInt(_cost) < 1) {
                errors.cost = true;
                stop = true;
            }
            if (_days === '') {
                errors.days = true;
                stop = true;
            }
        } else {
            _cost = '0';
            _days = '0';
        }
        setErr(errors);
        if (stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details/edit-insurance',
            {
                id: props.staffId,
                has: _has ? '1' : '0',
                cost: _cost,
                days: _days,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.onDone();
                props.closeHandler();
                ShowSnackbar(
                    'اطلاعات بیمه کارمند ویرایش شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>ویرایش بیمه کارمند</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>وضعیت بیمه:</label>
                        <button className={"techaran-switch" + (hasInsurance ? ' active' : '')}
                                onClick={() => setHasInsurance(v => !v)}>
                            <i><b/></i>
                            <span>{hasInsurance ? 'دارای بیمه' : 'بدون بیمه'}</span>
                        </button>
                        {
                            hasInsurance ?
                                <>
                                    <div style={{height: 10}}/>
                                    <label htmlFor={ids.cost}>مبلغ بیمه:</label>
                                    <input type="number"
                                           className={"form-control" + (err.cost ? ' is-invalid' : '')}
                                           id={ids.cost}
                                           min={0}
                                           value={cost}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setCost(ToxicDigitsFixToEnglish(t));
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.cost = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    {
                                        cost !== '' ?
                                            <span style={{
                                                display: 'block',
                                                margin: '5px 0 0 0',
                                                fontWeight: 400,
                                                color: '#0a53be'
                                            }}>{NumberToPersianLetters(parseInt(cost)) + " تومان"}</span> : null
                                    }
                                    <div className={"invalid-feedback" + (err.cost ? ' d-block' : ' d-none')}>
                                        لطفا یک مبلغ وارد نمایید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label htmlFor={ids.days}>تعداد روزهای بیمه در ماه:</label>
                                    <input type="number"
                                           className={"form-control" + (err.days ? ' is-invalid' : '')}
                                           id={ids.days}
                                           min={1}
                                           max={30}
                                           value={days}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setDays(ToxicDigitsFixToEnglish(t));
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.days = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div className={"invalid-feedback" + (err.days ? ' d-block' : ' d-none')}>
                                        لطفا یک عدد وارد نمایید.
                                    </div>
                                </> : null
                        }
                        <div className="d-flex justify-content-end align-items-center" style={{gap: 10, marginTop: 20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};